import { createApi } from "@reduxjs/toolkit/query/react";
import { privateBaseQuery } from "../base/private/privateBaseQuery";

export interface Department {
  id: number;
  name: string;
  description?: string | null;
}

export interface Specialization {
  id: number;
  name: string;
  department_id?: number | null;
}

interface GetDepartmentsResponse {
  status: string;
  status_code: string;
  entities: Department[];
}

interface GetSpecializationsResponse {
  status: string;
  status_code: string;
  entities: Specialization[];
}

export const departmentApi = createApi({
  reducerPath: "departmentApi",
  baseQuery: privateBaseQuery(),
  endpoints: (builder) => ({
    getDepartments: builder.query<Department[], void>({
      query: () => ({
        url: "/departments",
        method: "GET",
        params: { page: 0 },
      }),
      transformResponse: (response: GetDepartmentsResponse) =>
        response.entities ?? [],
    }),
    getSpecializations: builder.query<Specialization[], { department_id?: number | null }>({
      query: ({ department_id }) => ({
        url: "/specializations",
        method: "GET",
        params: department_id ? { department_id } : {},
      }),
      transformResponse: (response: GetSpecializationsResponse) =>
        response.entities ?? [],
    }),
  }),
});

export const { useGetDepartmentsQuery, useGetSpecializationsQuery } = departmentApi;
